import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/companyDetails/index',
    name: 'companyDetailsIndex',
    component: () => import('@/sub-app/companyDetails/pages/index.vue'),
    meta: {
      title: '入驻企业库',
      keepAlive: false,
    },
  },
  {
    path: '/companyDetails/companyInfo',
    name: 'companyDetailsCompanyInfo',
    component: () => import('@/sub-app/companyDetails/pages/companyInfo.vue'),
    meta: {
      title: '企业详情',
      keepAlive: false,
    },
  },
  {
    path: '/companyDetails/companySearch',
    name: 'companyDetailsCompanySearch',
    component: () => import('@/sub-app/companyDetails/pages/companySearch.vue'),
    meta: {
      title: '企业搜索',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  document.title = to.meta?.title || '';
  next();
});

export default router;
